exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.slide-lite {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.slide-lite .slide-lite-wrap {\n  display: flex;\n}\n.slide-lite .slide-item {\n  position: relative;\n  width: 100%;\n}\n", ""]);

